export const VEHICLE_CATEGORIES = ['45', '65', '95'];
export const LARGE_EQUIPMENT_CATEGORY = ['33'];
